import cn from 'classnames';
import { useIsExistingCustomer } from 'hooks/common/use-is-existing-customer';
import useNavigationData from 'hooks/navigation/use-navigation-data';
import Link from 'next/link';
import React from 'react';
import { isAbsoluteUrl } from 'utils/url';
import UspBar from '../usp-bar';
import styles from './top-header.module.css';

const HeaderTop: React.ComponentType = () => {
  const { trustbar } = useNavigationData();
  const { isEc, loading } = useIsExistingCustomer();
  const showUspBar = !loading && !isEc;

  return (
    <div className="bg-grey-100 w-full">
      <div className="mx-auto lg:container">
        {/* Trustbar for desktop */}
        <div
          className={cn(
            styles.headerTopMaxWidth,
            'hidden h-8 items-center text-center text-sm leading-none lg:flex'
          )}
        >
          <div className="relative flex w-full items-center justify-end">
            {showUspBar && (
              <div data-test="promo-banner2" className="absolute w-full">
                <UspBar variant="embedded-top" />
              </div>
            )}
            <div className="z-50 flex items-center justify-end pr-8">
              {trustbar.map((item) => {
                if (item && isAbsoluteUrl(item.url)) {
                  return (
                    <a
                      key={item.url}
                      data-test={`desktop-trustbar-${item.title}`}
                      href={item.url}
                      target={item.target}
                      rel={item.rel}
                      className="pt-pxleading-none text-primary-main ml-4 flex cursor-pointer justify-end"
                    >
                      <span className="hover:underline">{item.title}</span>
                    </a>
                  );
                } else {
                  return (
                    <Link
                      key={item.url}
                      href={item.url}
                      passHref
                      className="pt-pxleading-none text-primary-main ml-4 flex cursor-pointer justify-end"
                    >
                      <span className="hover:underline">{item.title}</span>
                    </Link>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;
